module.exports = __webpack_public_path__ + "2-o2.gif?194a788993995a65700fba7a55c70cdd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/2-o2.gif
// module id = 639
// module chunks = 0